'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import ErrorPage, { errorTemplates } from '@sbt-web/errors-page';
import '@sbt-web/errors-page/dist/index.css';

function ErrorComponent({
  error,
}: Readonly<{
  error: Error & { digest?: string };
  reset: () => void;
}>) {
  useEffect(() => {
    if (error) {
      error.message = `Page is broken: ${error.message}`;
      Sentry.captureException(error);
    } else {
      Sentry.captureException(
        'Page is broken: client side runtime error; no stack available'
      );
    }
  }, [error]);

  return <ErrorPage {...errorTemplates['500']} />;
}

export default ErrorComponent;
